import { __ } from '@wordpress/i18n';
import { useBlockProps, InspectorControls, URLPopover } from "@wordpress/block-editor";
import { registerBlockType } from "@wordpress/blocks";
import { useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import metadata from "./block.json";




registerBlockType(metadata.name, {...metadata, edit: EditComponent });

function EditComponent(props) {
  const { attributes, setAttributes } = props;
  const {} = attributes;


  return (
    <>
      <div id="parent" {...useBlockProps()}>
		<header>
			<nav class="navbar fixed-top" id="main_menu" aria-label="Menu principal">
				<div class="container container-max justify-content-end">
					<a class="navbar-brand" href="<?php echo get_home_url(); ?>">
						<img decoding="async" src="https://localhost/INA_IP_WEBSITE_2024/INA_IP_WEBSITE_2024/wp-content/uploads/2024/06/Logo_INA.svg" alt="INA, I. P." />
					</a>
					<button class="btn btn-search ms-auto me-2" type="button" aria-label="Abrir Pesquisa"
						data-bs-toggle="modal" data-bs-target="#modalSearch">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
							<path
								d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
						</svg>
					</button>
					<button class="btn btn-menu closed" type="button" data-bs-toggle="offcanvas"
						data-bs-target="#offCanvasMenu" aria-controls="offCanvasMenu" aria-label="Abrir menu de navegação">
						<span class="icon-menu me-2">
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
						</span>
						Menu
					</button>
					<div class="collapse navbar-collapse justify-content-end" id="main-menu">
					</div>
				</div>
			</nav>
			<div class="offcanvas offcanvas-start" tabindex="-1" id="offCanvasMenu" aria-labelledby="offCanvasMenuLabel">
				<div class="offcanvas-body px-5">
					<div class="row h-100">
						<div class="col-lg-3">
							<div class="card card-menu border-0 h-100">
								<div class="card-body p-0">
									<ul class="navbar-nav">

									</ul>
								</div>
							</div>
						</div>
						<div class="col-lg-3">
							<div class="card card-menu border-0 h-100">
								<div class="card-body p-0">
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal rounded-0 fade" id="modalSearch" tabindex="-1" aria-labelledby="modalSearchLabel" aria-hidden="true">
				<div class="modal-dialog modal-lg">
					<div class="modal-content border-0">
						<div class="modal-header border-0 pt-4 px-4 pb-2">
							<div class="search-filter position-relative w-100">
								<form role="search" method="get" id="searchform" action="<?php echo esc_url(home_url('/')); ?>">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
										<path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z">
										</path>
									</svg>
									<input type="text" class="form-control form-control-lg" name="s" id="search-input" placeholder="Pesquisar..." aria-label="Pesquisar..." aria-describedby="pesquisar"/>
								</form>
							</div>
						</div>
						<div class="modal-body px-4 mb-4">
							<p class="title-search small text-primary mb-2">Setor de pesquisa</p>
							<div id="searchResults" class="list-group">

							</div>
						</div>
						<div class="modal-footer text-end">
							<div class="help d-flex align-items-center">
								<svg width="15" height="15" aria-label="Tecla escape" role="img">
									<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2">
										<path d="M13.6167 8.936c-.1065.3583-.6883.962-1.4875.962-.7993 0-1.653-.9165-1.653-2.1258v-.5678c0-1.2548.7896-2.1016 1.653-2.1016.8634 0 1.3601.4778 1.4875 1.0724M9 6c-.1352-.4735-.7506-.9219-1.46-.8972-.7092.0246-1.344.57-1.344 1.2166s.4198.8812 1.3445.9805C8.465 7.3992 8.968 7.9337 9 8.5c.032.5663-.454 1.398-1.4595 1.398C6.6593 9.898 6 9 5.963 8.4851m-1.4748.5368c-.2635.5941-.8099.876-1.5443.876s-1.7073-.6248-1.7073-2.204v-.4603c0-1.0416.721-2.131 1.7073-2.131.9864 0 1.6425 1.031 1.5443 2.2492h-2.956">
										</path>
									</g>
								</svg>
							</div>
							<span class="help-label">para fechar</span>
						</div>
					</div>
				</div>
			</div>
		</header>
      </div>
    </>
  );
}

